var footer_mailing_list = (function( $ ) {

	var _init = function() {
		handle_responsive_display();
	};

	function handle_responsive_display() {
		var windowWidth = $( window ).width();
		if ( windowWidth < 768 ) {
			$( '#desktop-display-mailing-list' ).remove();
		} else {
			$( '#responsive-display-mailing-list' ).remove();
		}
	}

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = footer_mailing_list;